import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {CommonFormService} from 'src/app/shared/utils/common-form.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {moduloVMI} from '../../../diccionarios/moduloVMI';
import {VmiArticulosService} from '../../../services/administracion/vmi-articulos.service';
import {AG_GRID_LOCALE_ES} from '../../../diccionarios/spanishAgGrid';
import {VmiTanquesService} from '../../../services/administracion/vmi-tanques.service';
import {VmiClientesService} from '../../../services/administracion/vmi-clientes.service';
import {ArticuloModel} from '../../../models/vmi-articuloModel';
import {ClienteModel} from '../../../models/vmi-clienteModel';
import {TanqueModel} from '../../../models/vmi-tanqueModel';

@Component({
  selector: 'app-vmi-frm-mantenedor-tanques',
  templateUrl: './vmi-frm-mantenedor-tanques.component.html',
  styleUrls: ['./vmi-frm-mantenedor-tanques.component.css']
})
export class VmiFrmMantenedorTanquesComponent implements OnInit {

  formulario: FormGroup;

  columnDefs: any[];
  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;
  loading: boolean = false;
  listaVacia: boolean = true;

  textBoton: string;
  textoBuscar: string;
  mostrarFormulario: boolean = false;

  modulo: any = {};
  editableForm: boolean = false;

  DAT_TITULOS: any;
  titulo: any;
  AG_GRID_LOCALE_ES: any = {};

  cmbClientes: ClienteModel[] = [];
  cmbArticulos: ArticuloModel[] = [];

  constructor(
    private fb: FormBuilder,
    private _utils: UtilsService,
    private commonFormService: CommonFormService,
    private _tanques: VmiTanquesService,
    private _articulo: VmiArticulosService,
    private _cliente: VmiClientesService
  ) {
  }

  ngOnInit(): void {
    this.modulo = moduloVMI;
    this.textBoton = this.modulo.button.buttonsNombre.guardar;
    this.AG_GRID_LOCALE_ES = AG_GRID_LOCALE_ES;
    this.DAT_TITULOS = this.modulo.titulos.tanques;
    this.titulo = this.DAT_TITULOS.tituloCardListar;

    this.formulario = this.fb.group({
      tanqueId: [''],
      equiId: ['', [Validators.required]],
      tanqueSerialNumber: ['', [Validators.required]],
      tanqueDescripcion: ['', [Validators.required]],
      tanqueCapacidad: ['', [Validators.required]],
      tanqueDensidad: ['', [Validators.required]],
      cliente: ['', [Validators.required]],
      articulo: ['', [Validators.required]]
    });

    this.gridComponent();
    this.getAll();
    this.getAllClientes();
    this.getAllArticulos();
  }

  //*SERVICIOS
  getAll() {
    this._tanques.getAll().subscribe((res: any[]) => {
      this.loading = false;
      this.rowData = res;
      this.listaVacia = (this.rowData.length === 0) ? true : false;
    }, (err) => {
      console.log(err);
      this.loading = false;
      this.rowData = [];
      this.listaVacia = true;
    });
  }

  getAllClientes() {
    this._cliente.getAll().subscribe((res: ClienteModel[]) => {
      this.cmbClientes = res;
    }, (err) => {
      this.cmbClientes = [];
    });
  }

  getAllArticulos() {
    this._articulo.getAll().subscribe((res: ArticuloModel[]) => {
      this.cmbArticulos = res;
    }, (err) => {
      this.cmbArticulos = [];
    });
  }

  gridComponent() {
    this.columnDefs = [
      {
        headerName: 'No',
        field: 'tanqueId',
        sortable: true,
        filter: true,
        width: 100
      },
      {
        headerName: 'SERIAL NUMBER',
        field: 'tanqueSerialNumber',
        sortable: true,
        filter: true,
        width: 180
      },
      {
        headerName: 'DESCRIPCIÓN',
        field: 'tanqueDescripcion',
        sortable: true,
        filter: true,
        width: 300
      },
      {
        headerName: 'CAPACIDAD',
        field: 'tanqueCapacidad',
        sortable: true,
        filter: true,
        width: 180
      },
      {
        headerName: 'DENSIDAD',
        field: 'tanqueDensidad',
        sortable: true,
        filter: true,
        width: 180
      },
      {
        headerName: 'CLIENTE',
        field: 'cliente.cliNombre',
        sortable: true,
        filter: true,
        width: 300
      },
      {
        headerName: 'ARTÍCULO',
        field: 'articulo.artDescripcion',
        sortable: true,
        filter: true,
        width: 300
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.modulo.button.buttonsNombre.editar,
          colorBoton: this.modulo.button.buttonsCss.info
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.modulo.button.buttonsNombre.eliminar,
          colorBoton: this.modulo.button.buttonsCss.danger
        }
      }
    ];
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  nuevo() {
    this.commonFormService.abrirFormularioParaGuardar(this);
    this.titulo = this.DAT_TITULOS.tituloCardGuardar;
  }

  editar({rowData}) {
    const tanque: TanqueModel = rowData;
    const obj = {
      tanqueId: tanque.tanqueId,
      equiId: tanque.equiId,
      tanqueSerialNumber: tanque.tanqueSerialNumber,
      tanqueDescripcion: tanque.tanqueDescripcion,
      tanqueCapacidad: tanque.tanqueCapacidad,
      tanqueDensidad: tanque.tanqueDensidad,
      cliente: tanque.cliente.cliId,
      articulo: tanque.articulo.artId,
    };
    this.commonFormService.abrirFormularioParaEditar(this, obj);
    this.titulo = this.DAT_TITULOS.tituloCardEditar
  }

  eliminar({rowData}) {
    const tanque: TanqueModel = rowData;
    this._utils.confirmarSincronoPromesa({
      title: this.modulo.mensajes.eliminar,
      text: ``,
      action: this.modulo.button.buttonsNombre.eliminar,
      funcion: this._tanques.delete(tanque.tanqueId),
    }).then((res: any) => {
      this.getAll();
    }).catch((err) => {
      console.log(err);
    });
  }

  acciones(event) {
    if (event === 'guardar') {
      if (this.editableForm) {
        this.actualizar();
      } else {
        this.guardar();
      }
    } else {
      this.regresar();
    }
  }

  guardar() {
    const idCliente: number = Number(this.formulario.get('cliente').value);
    const idArticulo: number = this.formulario.get('articulo').value;
    const tanque: TanqueModel = Object.assign({}, this.formulario.value);
    tanque.articulo = this.cmbArticulos.find(articulo => articulo.artId === idArticulo);
    tanque.cliente = this.cmbClientes.find(cliente => cliente.cliId === idCliente);
    console.log(tanque);
    this._utils.confirmarSincronoPromesa({
      title: this.modulo.mensajes.guardar,
      text: ``,
      action: this.modulo.button.buttonsNombre.guardar,
      funcion: this._tanques.create(tanque),
    }).then((res: any) => {
      this.getAll();
      this.regresar();
    }).catch((err) => {
      console.log(err);
    });
  }

  actualizar() {
    const idCliente: number = Number(this.formulario.get('cliente').value);
    const idArticulo: number = this.formulario.get('articulo').value;
    let tanque: TanqueModel = Object.assign({}, this.formulario.value);
    tanque.articulo = this.cmbArticulos.find(articulo => articulo.artId === idArticulo);
    tanque.cliente = this.cmbClientes.find(cliente => cliente.cliId === idCliente);
    console.log(tanque);
    this._utils.confirmarSincronoPromesa({
      title: this.modulo.mensajes.actualizar,
      text: ``,
      action: this.modulo.button.buttonsNombre.actualizar,
      funcion: this._tanques.edit(tanque),
    }).then((res: any) => {
      this.getAll();
      this.regresar();
    }).catch((err) => {
      console.log(err);
    });
  }

  regresar() {
    this.titulo = this.DAT_TITULOS.tituloCardListar;
    this.commonFormService.limpiarYregrear(this);
  }

}
